import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-0.5 w-full rounded-full bg-black bg-opacity-10 relative dark:bg-white dark:bg-opacity-5" }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiProgress',
  props: {
  value: { type: Number, default: 0 },
  min: { type: Number, default: 0 },
  max: { type: Number, default: 100 },
},
  setup(__props) {

const props = __props



const width = computed(
  () =>
    Math.round(((props.value - props.min) / (props.max - props.min)) * 100) +
    "%"
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "absolute left-0 top-0 bottom-0 rounded-full transition-all duration-300 bg-blue-500",
      style: _normalizeStyle({ width: _unref(width) })
    }, null, 4)
  ]))
}
}

})